var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgPrivateNode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 65,
    viewBox: "0 0 84 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.3281,
    y: 0.606445,
    width: 64,
    height: 64,
    rx: 16,
    fill: "white",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_734_1032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.3462 58.1611C69.7561 58.1611 79.8164 48.1008 79.8164 35.6909C79.8164 23.2809 69.7561 13.2207 57.3462 13.2207C44.9362 13.2207 34.876 23.2809 34.876 35.6909C34.876 48.1008 44.9362 58.1611 57.3462 58.1611Z",
    fill: "url(#paint0_radial_734_1032)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7279 39.0371C81.7279 41.1507 79.6619 43.2049 75.8529 44.8783C72.0437 46.5517 66.7063 47.7502 60.6748 48.2862C54.6434 48.8224 48.2579 48.6658 42.5167 47.8413C36.7754 47.0167 32.0019 45.5705 28.9424 43.7288",
    stroke: "url(#paint1_linear_734_1032)",
    strokeWidth: 2.39045,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15527 11.4277L80.9837 36.0567",
    stroke: "url(#paint2_linear_734_1032)",
    strokeWidth: 2.39045,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_734_1032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.1559 49.0697) rotate(-133.933) scale(44.2149 40.1819)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.619792,
    stopColor: "#1B0A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#A83CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "#FFDFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_734_1032",
    x1: 25.339,
    y1: 48.6029,
    x2: 36.51,
    y2: 14.5945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.190577,
    stopColor: "#F5BAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427388,
    stopColor: "#F5BAFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_734_1032",
    x1: 2.18885,
    y1: 11.4428,
    x2: 9.19316,
    y2: -1.83302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.190577,
    stopColor: "#BAFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427388,
    stopColor: "#AFD4F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_734_1032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.1875,
    height: 51,
    fill: "white",
    transform: "translate(0.453125 8.27832)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPrivateNode);
export default __webpack_public_path__ + "static/media/img-private-node.f54c147c5177dd064ebd860e409fac36.svg";
export { ForwardRef as ReactComponent };